import Message from './message'
import EeCard from './card/Card.vue'
import EeCheckbox from './checkbox/Checkbox.vue'
import EeCol from './col/Col.vue'
import EeDialog from './dialog/Dialog.vue'
import EeForm from './form/Form.vue'
import EeLabel from './label/Label.vue'
import EeFormItem2 from './form/FormItem2.vue'
import EeFormItem from './form/FormItem.vue'
import EePager from './pager/Pager.vue'
import EePagerSsr from './pager/PagerSSR.vue'
import EeRow from './row/Row.vue'
import EeBanner from './banner/Banner.vue'
import EeTextarea from './textarea/Textarea.vue'
import EeProgressBar from './progess/ProgressBar.vue'
import EeSwitch from './switch/Switch.vue'
import EeSelect from './select/Select.vue'
import EeSelectBox from './select/SelectBox.vue'
import EeDropdown from './dropdown/Dropdown.vue'
import EeUpload from './upload/Upload.vue'
import EeUploadMulti from './upload/UploadMulti.vue'
import EeLocalData from './localdata/LocalData.vue'
import EeDataSelect from './localdata/DataSelect.vue'
import LocalDataSingle from './localdata/LocalDataSingle.vue'
const comps = [
  EeCol,
  EeRow,
  EeForm,
  EeCard,
  EeLabel,
  EePager,
  EeUpload,
  EeDialog,
  EeSwitch,
  EeSelect,
  EeBanner,
  EeTextarea,
  EeCheckbox,
  EeDropdown,
  EePagerSsr,
  EeFormItem,
  EeFormItem2,
  EeLocalData,
  EeSelectBox,
  EeDataSelect,
  EeUploadMulti,
  EeProgressBar,
  LocalDataSingle
]
export default {
  install (Vue, opt) {
    function toggleLoading (el, binding) {
      if (binding.value) {
        el.originalPosition = el.style.position
        el.originalOverflow = el.style.overflow
        if (!/fixed|absolute|relative/.test(el.originalPosition)) {
          el.style.position = 'relative'
        }
        el.style.overflow = 'hidden'
        el.appendChild(el.mask)
        el.inserted = true
      } else {
        el.style.position = el.originalPosition
        el.style.overflow = el.originalOverflow
        el.inserted && el.removeChild(el.mask)
        el.inserted = false
      }
    }
    Vue.directive('loading', {
      bind (el, binding) {
        if (!el.mask) {
          el.mask = document.createElement('div')
          el.mask.style.position = 'absolute'
          el.mask.style.width = '100%'
          el.mask.style.height = '100%'
          el.mask.style.zIndex = 9999
          el.mask.style.top = 0
          el.mask.style.left = 0
          el.mask.style.right = 0
          el.mask.style.bottom = 0
          el.mask.style.backgroundColor = 'rgba(0, 0, 0, .5)'
        }
        toggleLoading(el, binding)
      },
      update (el, binding) {
        if (binding.value !== binding.oldValue) {
          toggleLoading(el, binding)
        }
      },
      unbind (el) {
        el.inserted && el.removeChild(el.mask)
        el.inserted = undefined
        el.mask = null
      }
    })
    comps.forEach(component => Vue.component(component.compName, component))
    Vue.prototype.$message = Message
  }
}



// WEBPACK FOOTER //
// ./src/packages/index.js